jQuery(window).resize(function($) {
 //console.log('The window has been resized.');
});